"use client";

import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { isMobile } from "react-device-detect";

import { useWatchlistContext } from "@/context/use-context/watchlist-provider/client";
import { Tooltip } from "@mui/material";

export const WatchlistToggle = () => {
  const { isOpen, setIsOpen } = useWatchlistContext();

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  return isMobile ? (
    <ClipboardDocumentListIcon
      width={24}
      height={24}
      className="cursor-pointer text-white"
      role="button"
      onClick={onClick}
      aria-label="toggle watchlist"
      aria-expanded={isOpen}
    />
  ) : (
    <Tooltip
      arrow
      title="Watchlist"
      placement="bottom"
      PopperProps={{
        style: {
          zIndex: 100000,
        },
      }}
    >
      <ClipboardDocumentListIcon
        aria-label="toggle watchlist"
        onClick={onClick}
        width={24}
        height={24}
        className="cursor-pointer text-white"
        role="button"
        aria-expanded={isOpen}
      />
    </Tooltip>
  );
};
